import axios from "axios";

function getStoredPort() {
  try {
    const storedPort = JSON.parse(localStorage.getItem("port_awal") || "null");
    return storedPort && storedPort.value ? storedPort.value : "";
  } catch (error) {
    return "";
  }
}

function getStoredUserId() {
  try {
    const storedUser = JSON.parse(localStorage.getItem("user") || "null");
    return storedUser && storedUser.user_id ? storedUser.user_id : "";
  } catch (error) {
    return "";
  }
}

axios.interceptors.request.use(config => {
  const token = localStorage.getItem("token") ?? "";
  const port = getStoredPort();
  const user_id = getStoredUserId();

  config.params = {
    ...config.params,
    token,
    port,
    user_id
  };

  return config;
});

axios.interceptors.response.use(
  response => response,
  error => {
    if (
      error.response &&
      error.response.status === 403 &&
      error.response.data.message === "No Access"
    ) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      localStorage.removeItem("port_awal");
      window.location.href = "/login";
    }

    return Promise.reject(error);
  }
);
